import navigation from './js/navigation.js';
import intersectionObserver from './js/intersection-observer.js';
import HeroSwiper from './js/hero-swiper.js';
import ShowHeroSwiper from './js/show-hero-swiper.js';
import HeroFilter from './js/hero-filter.js';
import ShowTheme from './js/show-theme.js';
import ShowtimesDateSwiper from './js/show-date-swiper.js';
import ContactForm from './js/contact-form.js';
import FAQs from './js/faqs.js';
import EmploymentForm from './js/employment-form.js';

import './scss/main.scss';

navigation();
intersectionObserver();
HeroSwiper();
ShowHeroSwiper();
ShowTheme();
HeroFilter();
ShowtimesDateSwiper();
ContactForm();
FAQs();
EmploymentForm();